import React from "react";
import BlogCreateContainer from "../../../../Component/Application/blogs/CreateBlog/BlogCreate";

const AddBlog = () => {
  return (
    <div className="page-body">
      <BlogCreateContainer />
    </div>
  );
};

export default AddBlog;
